import React, { useState } from 'react';

import { toastPool } from '../../toasts/models/toast-pool';
import { Toast } from '../../toasts/models/toast';
import { openModal } from '../../../core/modal/open-modal';
import { PurchaseCreditsModal } from '../../../routes/space/settings/purchase-credits.modal';
import { AlertDialog } from '../../../components/dialogs/alert.dialog';
import { context } from '../../../app/context';

interface InsufficientCreditsDialogProps {
  onClose: () => void;
}

export const InsufficientCreditsDialog: React.FC<InsufficientCreditsDialogProps> = ({
  onClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const currentMember = context.member;
  const space = context.space;

  const handleCancel = () => {
    onClose();
  };

  const handleRequestCredits = async () => {
    if (!currentMember || isLoading) return;

    setIsLoading(true);

    try {
      await currentMember.requestCredits();
      toastPool.insert(new Toast('Credits successfully requested', 'success'));
      handleCancel();
    } finally {
      setIsLoading(false);
    }
  };

  const handlePurchaseCredits = async () => {
    handleCancel();
    openModal(PurchaseCreditsModal, { space });
  };

  let title = 'Purchase credits';
  let description =
    'There are not enough credits available in your space to perform this action. Please consider purchasing additional credits.';
  let buttonText = 'Request extra credits';
  let action = handleRequestCredits;

  if (currentMember?.role === 'guest') {
    title = 'Request credits';
    description =
      'There are not enough credits available in your space to perform this action. Please consider requesting additional credits from the space owner.';
  }

  if (currentMember && currentMember.flags['organization_settings.payment_management']) {
    buttonText = 'Buy credits';
    action = handlePurchaseCredits;
  }

  return (
    <AlertDialog
      title={title}
      onCancel={onClose}
      description={description}
      buttonText={buttonText}
      onAccept={action}
    />
  );
};
